import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  BookmarkFillIcon, BookmarkIcon, PackageIcon,
  StarIcon, MapPinIcon, RefreshIcon, ArrowRightIcon,
} from '../../components/Icons';

const BASE  = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const token = () => localStorage.getItem('kialuga_token');

export default function Favoritos() {
  const navigate = useNavigate();
  const [favoritos,  setFavoritos]  = useState([]);
  const [load,       setLoad]       = useState(true);

  useEffect(() => { carregar(); }, []);

  const carregar = async () => {
    setLoad(true);
    try {
      const res  = await fetch(`${BASE}/favoritos`, { headers: { Authorization: `Bearer ${token()}` } });
      const data = await res.json();
      if (data.sucesso) setFavoritos(data.favoritos || []);
    } catch {}
    finally { setLoad(false); }
  };

  const remover = async (anuncio_id) => {
    try {
      await fetch(`${BASE}/favoritos/${anuncio_id}`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token()}` },
      });
      setFavoritos(prev => prev.filter(f => f.anuncio_id !== anuncio_id));
    } catch {}
  };

  return (
    <>
      <div className="topbar">
        <div>
          <div className="topbar-title">Os meus favoritos</div>
          <div className="topbar-sub">{favoritos.length} produto{favoritos.length !== 1 ? 's' : ''} guardados</div>
        </div>
        <div className="topbar-actions">
          <button className="btn btn-outline" onClick={carregar} style={{display:'flex',alignItems:'center',gap:'6px'}}>
            <RefreshIcon size={14}/> Actualizar
          </button>
          <button className="btn btn-primary" onClick={() => navigate('/cliente')} style={{display:'flex',alignItems:'center',gap:'6px'}}>
            <PackageIcon size={14}/> Explorar mais
          </button>
        </div>
      </div>

      <div className="page-content">
        {load ? (
          <div style={{textAlign:'center',padding:'60px',color:'var(--text-muted)'}}>A carregar favoritos...</div>
        ) : favoritos.length === 0 ? (
          <div className="card" style={{textAlign:'center',padding:'60px 20px'}}>
            <BookmarkIcon size={40} color='var(--border)'/>
            <div style={{fontSize:'15px',fontWeight:'600',marginTop:'12px',marginBottom:'6px'}}>Sem favoritos ainda</div>
            <div style={{fontSize:'13px',color:'var(--text-muted)',marginBottom:'20px'}}>
              Guarda produtos que te interessem para os encontrar facilmente.
            </div>
            <button className="btn btn-primary" onClick={() => navigate('/cliente')} style={{display:'inline-flex',alignItems:'center',gap:'6px'}}>
              <PackageIcon size={14}/> Explorar produtos <ArrowRightIcon size={14}/>
            </button>
          </div>
        ) : (
          <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(260px,1fr))',gap:'14px'}}>
            {favoritos.map(f => (
              <div key={f.anuncio_id} className="card" style={{padding:0,overflow:'hidden',cursor:'pointer'}}
                onClick={() => navigate(`/cliente/produto/${f.anuncio_id}`)}>
                {/* Foto */}
                <div style={{height:'160px',background:'linear-gradient(135deg,#fde8d8,#fed7b0)',overflow:'hidden',position:'relative',display:'flex',alignItems:'center',justifyContent:'center'}}>
                  {f.fotos?.[0]
                    ? <img src={f.fotos[0]} alt={f.titulo} style={{width:'100%',height:'100%',objectFit:'cover'}} onError={e=>e.target.style.display='none'}/>
                    : <PackageIcon size={36} color='rgba(249,115,22,0.4)'/>
                  }
                  {/* Botão remover */}
                  <button
                    onClick={e => { e.stopPropagation(); remover(f.anuncio_id); }}
                    style={{position:'absolute',top:'8px',right:'8px',width:'30px',height:'30px',borderRadius:'50%',background:'rgba(0,0,0,0.45)',border:'none',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',backdropFilter:'blur(4px)'}}
                    title="Remover dos favoritos">
                    <BookmarkFillIcon size={14} color='#F97316'/>
                  </button>
                </div>

                <div style={{padding:'12px'}}>
                  <div style={{fontSize:'13px',fontWeight:'600',color:'var(--text-primary)',marginBottom:'4px',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{f.titulo}</div>
                  <div style={{display:'flex',alignItems:'center',gap:'4px',fontSize:'11px',color:'var(--text-muted)',marginBottom:'8px'}}>
                    <MapPinIcon size={11}/> {f.localizacao || 'Sem localização'}
                  </div>
                  <div style={{display:'flex',alignItems:'center',justifyContent:'space-between'}}>
                    <div>
                      <div style={{fontSize:'14px',fontWeight:'700',color:'var(--orange)'}}>{parseFloat(f.preco_dia||0).toLocaleString()} Kz/dia</div>
                      {f.rating_medio > 0 && (
                        <div style={{display:'flex',alignItems:'center',gap:'3px',fontSize:'11px',color:'var(--text-muted)'}}>
                          <StarIcon size={11} color='#f59e0b'/> {parseFloat(f.rating_medio).toFixed(1)}
                        </div>
                      )}
                    </div>
                    <button className="btn btn-primary btn-sm" style={{display:'flex',alignItems:'center',gap:'4px'}}
                      onClick={e => { e.stopPropagation(); navigate(`/cliente/produto/${f.anuncio_id}`); }}>
                      Ver <ArrowRightIcon size={12}/>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
}
